// from general.js
/* global dcAnalytics dcLocalStorage isMobileDevice userId toggleTeacherProfilePhotoUploadOverlay */
// from JSP
/* global teacherId teacherHasProfilePhoto teacherProfilePhotoURL */

import { showClassroomPhotoUploader } from '../teacherclassroomphoto/teacherClassroomPhotoPopup.js';
import { decorateFallbackForRetinaClassroomPhotoBG } from '../classroomPhoto/fallbackForRetinaClassroomPhoto.js';


$(document).ready(function () {
    /* ----------------------- */
    /* FUNCTIONS + CONSTANTS */
    /* ----------------------- */

    const DO_NOT_SHOW_INTRO_KEY = 'xProjectPageTeacherProfilePhotoIntro';

    function closeShowIntroOverlay(event) {
        if ($('.js-intro-teacher-photo-overlay').length > 0) {
            $('.js-intro-teacher-photo-overlay').hide();
            if ($(event.target).closest('.js-upload-photo-button').length === 0 && $(event.target).closest('.js-upload-photo-copy').length === 0) {
                $('.screen').remove();
            }
        }
    }

    /**
     * Business rules for 'New Feature!' intro:
     * 1. if teacher clicks 'x' at top-right => store value in local storage to not display intro again + close intro
     * 2. if teacher clicks 'upload a photo' button => store value in local storage to not display intro again + close intro + show 'upload photo' overlay
     * 3. if teacher clicks '+' below the intro => store value in local storage to not display intro again + close intro + show 'upload photo' overlay
     * 4. if teacher clicks gray overlay outside the intro => store value in local storage to not display intro again + close intro
     */

    function userIsProjectTeacher() {
        return (userId && teacherId && userId === teacherId);
    }

    function addProfilePhotoUploadSnippet(selector, photoURL) {
        let elem = '<a class="teacher-photo upload js-teacher-photo-upload js-click-on-enter-or-space" style="background-image: url(' + photoURL + ')">';
        elem += '<span class="upload-tooltip">Add a profile photo to raise your chances of getting funded.</span>';
        elem += '<span tabindex=0 role="link" aria-label="Upload teacher profile photo" class="upload-photo js-click-on-enter-or-space"></span>';
        elem += '</a>';
        $(selector).after(elem);
        $(selector).next().on('click', (event) => { toggleTeacherProfilePhotoUploadOverlay(event); });
        return elem;
    }

    function repositionTeacherInfoWrapper() {
        $('.teacher-info-wrapper').addClass('has-photo');
    }

    function checkForClassroomPhoto() {
        const backgroundImage = $('.classroom-photo').css('background-image');
        return backgroundImage &&
            backgroundImage !== 'none' &&
            backgroundImage.indexOf("images/classroom/fallback") === -1;
    }

    const teacherHasClassroomPhoto = checkForClassroomPhoto();

    function showClassroomPhotoEditForTeacherAndCorrectMargins() {
        if (userIsProjectTeacher() && !alreadyAddedPendingScreeningNotification()) {
            $('.js-classroom-photo-check').show();
            const photoUploadButton = $('.js-classroom-photo-upload');
            const hasPhotoUploadButton = photoUploadButton.length > 0;
            if (!hasPhotoUploadButton) {
                if (teacherHasClassroomPhoto) {
                    $('.js-classroom-photo-check').before('<a href="' + secureBaseURL + 'teacher/teacher_photo_upload.html" class="editable-link edit-classroom-photo change-classroom-photo js-classroom-photo-upload js-admin">Change your classroom photo</a>');
                } else {
                    $('.js-classroom-photo-check').before('<div class="add-classroom-photo"><svg class="icon icon-picture"><use xlink:href="/images/icon/icon-junior.svg#icon-picture"></use></svg><a href="' + secureBaseURL + 'teacher/teacher_photo_upload.html" class="editable-link edit-classroom-photo js-classroom-photo-upload js-admin">Add a classroom photo</a><p>Classroom photos helps donors picture your classroom<br>(Optional)</p></div>');
                }
                $('body').on('click', '.js-classroom-photo-upload', function (event) {
                    if (!isMobileDevice) {
                        event.preventDefault();
                        showClassroomPhotoUploader(this, event);
                    }
                });
            }
        }
        if (!$('.js-classroom-photo-check').is(':visible')) {
            $('.teacher-photo').addClass('fix-margin').addClass('sole-photo');
        }
    }

    $(window).on('userCookiesReset', function () {
        showClassroomPhotoEditForTeacherAndCorrectMargins();
        decorateFallbackForRetinaClassroomPhotoBG();
    });

    function alreadyAddedPendingScreeningNotification() {
        return $('.pending-screening').length > 0;
    }

    /* ------------- */
    /* CODE TO RUN */
    /* ------------- */

    if (userIsProjectTeacher()) {
        $.ajax({
            url: secureBaseURL + 'teacher/profile_photo_is_published.html?teacherId=' + teacherId,
            dataType: 'jsonp',
            success: function (data) {
                if (alreadyAddedPendingScreeningNotification()) {
                    // Hack: if we've already added stuff to the page to notify
                    // the teacher that their photo is pending screening,
                    // don't bother with any of this. Just leave things the way that code left it.
                    return;
                }

                if (data.profilePhotoIsPublished) {
                    addProfilePhotoSnippet('.classroom-photo', data.profilePhotoURLs['68']);
                    showClassroomPhotoEditForTeacherAndCorrectMargins();
                    repositionTeacherInfoWrapper();
                } else if (!isMobileDevice) {
                    addProfilePhotoUploadSnippet('.classroom-photo', data.profilePhotoURLs['68']);
                    showClassroomPhotoEditForTeacherAndCorrectMargins();
                    repositionTeacherInfoWrapper();
                    $('span.upload-photo').on('click', function (event) {
                        closeShowIntroOverlay(event);
                        dcLocalStorage.setValue(DO_NOT_SHOW_INTRO_KEY, 'true');
                        toggleTeacherProfilePhotoUploadOverlay(event);
                    });
                }
            },
        });
    } else if (teacherHasProfilePhoto) {
        addProfilePhotoSnippet('.classroom-photo', teacherProfilePhotoURL);
        showClassroomPhotoEditForTeacherAndCorrectMargins();
        repositionTeacherInfoWrapper();
    }

    function addProfilePhotoSnippet(selector, photoURL) {
        let elem = '<a class="teacher-photo" ';
        elem += 'href="' + baseURL + 'classroom/' + teacherId + '" ';
        elem += 'title="See this teacher\'s page" ';
        elem += 'style="background-image: url(' + photoURL + ')"></a>';
        $(selector).after(elem);
        $(selector).next().on('click', () => { dcAnalytics.trackEventGA([pageName, 'Teacher Photo', 'Teacher Search']); });
    }

    // JSONP callback from hideOverlayAndUpdateUnderlyingPageAfterTeacherProfilePhotoUploadCrop
    window.onTeacherProfilePhotoUploadCropCompletion = function (data) {
        if ($('.js-teacher-photo-upload').length > 0) {
            $('.js-teacher-photo-upload').remove();
            addProfilePhotoSnippet('.classroom-photo', data.photoPaths['68']);
            repositionTeacherInfoWrapper();
        }
    };
});
